import { Flex } from "@/atoms"
import { EXTERNAL_ROUTES } from "@/const/routes.constants"
import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { useTranslation } from "@/hooks/useTranslation"
import { useFeatureFlags } from "@/hooks/useUser"
import { CloudUploadOutlined } from "@/icons"
import { LinkButton } from "@/molecules/LinkButton"
import { Filter } from "@/organisms/FilterNew/Filter"
import { InputSmartSearchLoading, SmartSearch } from "@/organisms/SmartSearch"
import { useFiltersDeployments } from "@/pages/DeploymentsPage/application/useFiltersDeployments"
import { DeployButton } from "@/pages/DeploymentsPage/components/molecules/DeployButton"
import { getFilters } from "@/pages/DeploymentsPage/components/organisms/DeploymentsTab/getFilters"

export const FiltersDeploymentsTab = () => {
  const { response: options, isLoading: isLoadingFilters } =
    useFiltersDeployments()
  const dataReadinessFF = useFeatureFlags("dataReadiness")
  const filterDisabled = !!dataReadinessFF || isLoadingFilters
  const placement = "deployments-page"
  const { t } = useTranslation()
  const filters = getFilters(t)

  return (
    <Filter.Provider isLoading={filterDisabled}>
      <Filter.Template
        isLoading={filterDisabled}
        aside={
          <Flex align="center" gap={12}>
            {!isSelfHosted() && (
              <LinkButton
                size="small"
                type="link"
                href={`${EXTERNAL_ROUTES.API_DOCS}/change-log/runtime-sensor-releases`}
                target="_blank"
              >
                {t(`deployments.viewChangeLog`)}
              </LinkButton>
            )}
            <DeployButton name="Deploy" Icon={<CloudUploadOutlined />} />
          </Flex>
        }
        search={
          filterDisabled ? (
            <InputSmartSearchLoading />
          ) : (
            <SmartSearch data={options} filters={filters} />
          )
        }
      >
        <Filter.Checkbox
          keyFilter="environments"
          order="none"
          items={options?.environments}
          placeHolderDefaultValue="Environments"
          isLoading={filterDisabled}
          placement={placement}
        />
        <Filter.Checkbox
          keyFilter="statuses"
          order="none"
          items={options?.["statuses"]}
          placeHolderDefaultValue="Status"
          isLoading={filterDisabled}
          placement={placement}
        />
        <Filter.DatePicker
          placeholder="Last Upgrade"
          isLoading={filterDisabled}
          placement={placement}
        />
      </Filter.Template>
    </Filter.Provider>
  )
}
